import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { Observable, pipe } from 'rxjs';
import {catchError, map} from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { CommonService } from './common-service.service';
import { HttpService } from './http.service';
import { DriverMaster, DriverModelMap } from '../model/driver.model';
@Injectable({
  providedIn: 'root'
})
export class DriverMasterService{
hostname=environment.apiEndpoint;
modelMap: DriverModelMap = new DriverModelMap();
driverMasterObj:DriverMaster;
constructor(private _http : HttpClient, private commonService: CommonService, private httpService: HttpService) { }

  PostDriver(servicePath:any,data : any){
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this._http.post(this.hostname + servicePath, data, httpOptions).pipe(catchError(this.handleError));
  }

  GetDriver(servicePath:any,data:any){
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this._http.get<any>(this.hostname + servicePath, httpOptions).pipe(catchError(this.handleError))
  }

  ViewDriver(servicePath:any){
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this._http.get<any>(this.hostname + servicePath, httpOptions).pipe(catchError(this.handleError))
  }

  getSystemDate(servicePath:any){
    let headers = this.commonService.getHeaders();
    const httpOptions = { headers: headers };
    return this._http.get<any>(this.hostname + servicePath, httpOptions).pipe(catchError(this.handleError))
  }
  private handleError(error: HttpErrorResponse) {
    console.log(error)
    return Observable.throw(error.message || "Server Error")
  }
}
